var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 10.1833C11.4917 10.1833 12.875 8.80832 12.875 7.11666C12.875 5.42499 11.5 4.04166 9.8 4.04166C8.10834 4.04166 6.73334 5.41666 6.73334 7.11666C6.73334 8.81666 8.10834 10.1833 9.8 10.1833Z",
    fill: "#7A808A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 11.375H7.80834C5.84167 11.375 4.25 12.975 4.25 14.9333V15.5C4.25 16.3 4.90833 16.9583 5.70833 16.9583H14.3C15.1 16.9583 15.7583 16.3 15.7583 15.5V14.9417C15.7583 12.975 14.1583 11.375 12.2 11.375Z",
    fill: "#7A808A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileInactive);
export default __webpack_public_path__ + "static/media/profile_inactive.0df9187c0b003ccba0dc4960b37f1e46.svg";
export { ForwardRef as ReactComponent };